import ApplicationTypeRequests from '../../server/applicationType';
import { addLoading, removeLoading } from './loading';

export const getListApplicationType = (
  limit,
  skip,
  search,
  orderBy = 'DESC',
  field = 'createdAt',
  loading = true,
) => async (dispatch) => {
  if (loading) dispatch(addLoading());
  try {
    const result = await ApplicationTypeRequests.getListApplicationType(limit, skip, search, orderBy, field);
    return result;
  } finally {
    if (loading) dispatch(removeLoading());
  }
};

export const getOptionsApplicationType = search => async () => {
  const listApplicationType = await ApplicationTypeRequests.getOptionsApplicationType(search);
  return listApplicationType;
};

export const createApplicationType = newApplicationType => async (dispatch) => {
  dispatch(addLoading());
  try {
    await ApplicationTypeRequests.createApplicationType(newApplicationType);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateApplicationType = updApplicationType => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await ApplicationTypeRequests.updateApplicationType(updApplicationType);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};
